export const enum TranslationNamespace {
  APP = 'app',
  COMMON = 'common',
  DESIGN_STUDIO = 'designStudio',
  HOMEOWNER_APP = 'homeownerApp',
  PROPERTY_DETAILS = 'propertyDetails',
  LOGIN = 'login',
  NOT_FOUND = 'notFound',
  SHARED = 'shared',
  SIGN_UP = 'signUp',
  NEW_CONSTRUCTION = 'newConstruction',
  PAINT_MEASUREMENTS = 'paintMeasurements',
  SOMETHING_WRONG = 'somethingWrong',
}
